import { runImpactCalculateVenueCo2ForDate } from '@/domain/impact-calculate-venue/actions/run-impact-calculate-venue-co2-for-date.action';
import { ImpactCo2Answer } from '@/domain/impact-co2/entities/question.entity';
import { createAppAsyncThunk } from '@/domain/store.thunk';

import { submitImpactCo2Answer } from '../submit-impact-co2-answer.action';

type Params = {
  projectId: number;
  dateId: number;
  answer: ImpactCo2Answer;
  submitMode: 'create' | 'edit';
};

export const submitImpactCo2AnswerVenueDate = createAppAsyncThunk(
  'impactCo2/submitImpactCo2AnswerVenueDate',
  async ({ projectId, dateId, answer, submitMode }: Params, { dispatch }) => {
    await dispatch(
      submitImpactCo2Answer({
        answer,
        projectId: dateId,
        submitMode: submitMode,
        recalculateAfterSubmit: false,
      }),
    );
    dispatch(runImpactCalculateVenueCo2ForDate({ dateId, projectId }));
  },
);
